import "./utils/authStorage";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import "./assets/main.css";

// Global axios request interceptor: Har doim token bor bo'lsa Authorization header qo'shish
axios.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token") || localStorage.getItem("token");
  if (token && token !== "undefined" && token !== "null" && token.trim()) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Oktyabr sahifasida bo'lsa oquv_oktyabr bazasini ko'rsatish
  const routePath = router.currentRoute.value?.path || "";
  const currentPath = window.location.pathname || "";
  const isOktyabr = routePath.startsWith("/oktyabr") || currentPath.startsWith("/oktyabr") || (config.url && config.url.includes("/oktyabr"));
  if (isOktyabr) {
    config.params = config.params || {};
    config.params.period = "oktyabr";
  }

  return config;
});

// Global axios response interceptor: 401 (Unauthorized) bo'lsa darhol login sahifasiga chiqarish
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      if (error.response.status === 401) {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("user");
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        if (router.currentRoute.value?.name !== "login") {
          router.push({ name: "login" });
        }
      }
    }
    return Promise.reject(error);
  }
);

createApp(App).use(store).use(router).mount("#app");

